/**
 * @author huancheng.zhan<huancheng.zhan@ukelink.com>
 * @description
 * @since 2018/3/12
 */

import Axios from 'axios'

/**
 * @type {AxiosInstance}
 */
const service = Axios.create({
  timeout: 60000
})

service.interceptors.request.use(config => {
  return config
})

service.interceptors.response.use(response => {
  return response.data
}, error => {
  if (error.response) {
    return Promise.reject(error.response)
  }
})

export default service
